import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-component-image-display',
  templateUrl: './component-image-display.component.html',
  styleUrls: ['./component-image-display.component.scss']
})
export class ComponentImageDisplayComponent implements OnInit {

  constructor(public _dialogRef: MatDialogRef<ComponentImageDisplayComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any) { }
ImageSrc :string;
  ngOnInit(): void {
    this.ImageSrc= this._data.image;
  }

}
